import React from 'react'
import TextComponent from '../TextComponent';

import ico from 'images/products/wave_solder_pallets/through-hole-components.png'

const ThroughHoleQuantity = (props) => {
  const onChange = e => props.onChangeParameter(props.name, e.target.value);
  const value = props.parameters[props.name];
  return (
    <div className="row g-0 mb-3">
      <div className="col-4 col-md-3 col-lg-4">
        <img src={ico} alt="Through-Hol Quantities" className="img-fluid mb-3" />
      </div>
      <div className="col-8 col-md-4 col-lg-8 ps-3 ps-md-0 ps-lg-3">
        <TextComponent
          label={props.label}
          name={props.name}
          inputId={props.inputId}
          value={value || ''}
          required={props.required}
          onChange={onChange}
          tooltip={props.tooltip}
          min="1">
          {props.children}
        </TextComponent>
      </div>
    </div>
  );
}

ThroughHoleQuantity.defaultProps = {
  inputId: 'through_hole_component_pressed_quantity',
  label: 'How many through-hole components need to be pressed down with shoulder bolts? ($1 each)',
  name: 'through_hole_component_pressed_quantity',
  required: true,
};

export default ThroughHoleQuantity;
